var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('ul',{staticClass:"flex border-b border-blue-500 flex-wrap"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.name,class:{
          'is-active': tab.isActive,
          'flex-auto': _vm.justifyBetween,
          'flex-shrink-0': !_vm.justifyBetween,
        }},[_c('button',{staticClass:"block py-2 text-lg border-0 border-b-3",class:{
            'selected-tab': tab.isActive,
            'px-12': !_vm.justifyBetween,
          },attrs:{"href":tab.href,"disabled":tab.disabled},on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._t(`header-${tab.refName}`,function(){return [_vm._v(" "+_vm._s(tab.name)+" ")]})],2)])}),0)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }